export default __webpack_public_path__ + "static/media/icon3d__test.67e276c2.png";